/**
 * Seat circle labels: split on spaces so each word is its own line, allowing a larger font than one shrunk line.
 */
export function splitGuestNameIntoSeatLines(name: string): string[] {
  return name.trim().split(/\s+/).filter(Boolean);
}

export function guestSeatMultilineLabel(name: string): string {
  const parts = splitGuestNameIntoSeatLines(name);
  return parts.length > 0 ? parts.join('\n') : name.trim();
}
